import { useCallback, useState } from "react";
import { ArrowRight } from "lucide-react";
import { FrameSequenceCanvas } from "@/components/FrameSequenceCanvas";
import { useLanguage } from "@/context/LanguageContext";

// Scroll-driven "Krishna lifted" video sequence. As the visitor scrolls,
// hands lift baby Krishna up toward them; near the end the invitation and the
// "Show Me How" button fade in.
export const TakeKrishnaHome = ({ onShowMeHow }) => {
  const { t } = useLanguage();
  const [progress, setProgress] = useState(0);
  const onProgress = useCallback((p) => setProgress(p), []);

  const reveal = Math.min(Math.max((progress - 0.72) / 0.18, 0), 1);

  return (
    <section id="takehome" data-testid="take-home-section" className="relative h-[calc(var(--vph)*3.4)]">
      <div className="sticky top-0 h-[var(--vph)] w-full overflow-hidden">
        <FrameSequenceCanvas
          variant="cover"
          sectionSelector="#takehome"
          total={120}
          basePath="/images/krishna-lift"
          prefix="lift-"
          mobileContainUntil={64}
          onProgress={onProgress}
        />

        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#070b18] via-transparent to-transparent" />

        <div
          className="absolute inset-x-0 bottom-[calc(var(--vph)*0.1)] flex flex-col items-center px-6 text-center"
          style={{
            opacity: reveal,
            transform: `translateY(${(1 - reveal) * 24}px)`,
            pointerEvents: reveal > 0.6 ? "auto" : "none",
          }}
        >
          <h2
            data-testid="take-home-title"
            className="font-display text-5xl text-white drop-shadow-[0_2px_20px_rgba(0,0,0,0.6)] sm:text-6xl md:text-7xl"
          >
            {t.second.title}
          </h2>
          <p className="mt-4 max-w-md text-base text-amber-50/80 md:text-lg">
            {t.second.sub}
          </p>
          <button
            onClick={onShowMeHow}
            data-testid="show-me-how-btn"
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-amber-400 px-9 py-4 text-sm font-semibold tracking-wide text-[#0a1024] transition-all hover:bg-amber-300 hover:shadow-[0_0_40px_rgba(251,191,36,0.45)]"
          >
            {t.second.cta}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </section>
  );
};
